define('view/module/cart/CartView',['require','lib/view/LayoutView','lib/Utils','view/controller/booking/details/BookingLeaveConfirmationView','lib/view/ModalRegion','view/module/cart/CartPackageLinkView','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Utils = require('lib/Utils');

    var BookingLeaveConfirmationView = require('view/controller/booking/details/BookingLeaveConfirmationView');
    var ModalRegion = require('lib/view/ModalRegion');
    var CartPackageLinkView = require('view/module/cart/CartPackageLinkView');

    var Config = require('Config');

    return LayoutView.extend({

        template: '#cart_module_view',

        ui: {
            'checkout': '#sb_cart_checkout_btn',
            'qty': '.sb-qty',
            'total': '.sb-total',
            'totalBlock': '.sb-total-block',
            'tax': '.sb-tax',
            'pretotal': '.sb-pretotal',
            'taxBlock': '.sb-tax-block',
            'checkoutBlock': '.sb-checkout-block',
            'packageBlock': '.sb-package-block',
            'emptyBlock': '.sb-empty-block',
            'popup': '.sb-cart-popup',
            'closePopup': '.sb-cart-popup-close',
            'cartBtn': '.sb-cart-btn',
            'confirmLink': '.sb-confirm-leave a'
        },
    
        triggers: {
            'click @ui.checkout': {
                'event': 'checkout',
                'stopPropagation': false,
                'preventDefault': false
            }
        },

        events: {
            'click @ui.confirmLink': 'confirmLinkClick',
            'click @ui.closePopup': 'onClosePopup',
            'click @ui.cartBtn': 'onTogglePopup',
        },

        modelEvents: {
            'sync': 'updateState',
            'change': 'updateState',
            'add:item': 'onAddItem',
            'toggle:popup': 'onTogglePopup'
        },

        regions: {
            'products': '#sb_cart_products',
            'multipleBooking': '#sb_cart_multiple_bookings',
            'packageLink': '#sb_cart_package_link'
        },

        serializeData: function () {
            return _.extend(LayoutView.prototype.serializeData.call(this), {
                qty: this.model.getQty(),
                pretotal: this.getPreTotal(),
                total: this.getTotal(),
                tax: this.model.getTax(),
                currency: this.model.getCurrency(),
                //TODO if we want this data for package link, we should update it separately in updateState(), as the view is not rerendered on cart content changes
                // serviceIds: this.model.getServiceIds().join(','),
                // productIds: this.model.getProductIds().join(',')
            });
        },

        onRender: function () {
            if (Config.getInstance().getPluginStatus('package')) {
                this.packageLink.show(new CartPackageLinkView({
                    model: this.model
                }));
            }
        },

        // update elements manually to prevent rerender of regions
        updateState: function () {
            if (this.model.getQty()) {
                this.ui.checkoutBlock.show();
                this.ui.emptyBlock.hide();
                this.ui.popup.addClass('has-items');
            } else {
                this.ui.checkoutBlock.hide();
                this.ui.emptyBlock.show();
                this.ui.popup.removeClass('has-items');
            }

            if (this.model.getTotal()) {
                this.ui.totalBlock.show();
                this.ui.packageBlock.show();
            } else {
                this.ui.totalBlock.hide();
                this.ui.packageBlock.hide();
            }
            
            this.ui.qty.text(this.model.getQty());
            this.ui.pretotal.text(Utils.formatPrice(this.getPreTotal(), this.getCurrency()));
            this.ui.total.text(Utils.formatPrice(this.getTotal(), this.getCurrency()));

            if (this.model.getTax()) {
                this.ui.tax.text(Utils.formatPrice(this.getTax(), this.getCurrency()));
                this.ui.taxBlock.show();
            } else {
                this.ui.taxBlock.hide();
            }
        },

        onAddItem: function () {
            var popup = this.ui.popup;
            setTimeout(function() {
                //NB timeout to prevent the same click handled by popup closer
                popup.addClass('active');
                $('body').addClass('--cart-open');
            }, 100);
        },

        onClosePopup: function () {
            this.ui.popup.removeClass('active');
            $('body').removeClass('--cart-open');
        },

        onTogglePopup: function () {
            this.ui.popup.toggleClass('active');
            $('body').toggleClass('--cart-open');
        },

        confirmLinkClick: function (evt, params) {
            if (params && params.skipConfirmation) {
                return;
            }

            // console.log('confirmLinkClick', arguments);
            evt.preventDefault();
            evt.stopPropagation();
            
            var $target = $(evt.currentTarget);
            var link = $target.attr('href');
            
            var region = new ModalRegion();
            var view = new BookingLeaveConfirmationView();
            region.show(view);

            this.listenTo(view, 'confirm', function () {
                jQuery(evt.target).trigger('click', {skipConfirmation: true})
                if (link) {
                    window.location = link;
                }
            });
        },

        getTax: function () {
            return this.model.getTax();
        },

        getCurrency: function () {
            return this.model.getCurrency();
        },

        getPreTotal:  function () {
            if (Config.getInstance().getOption('price_includes_tax')) {
                return this.model.getTotal() - this.model.getTax();
            } else {
                return this.model.getTotal();
            }
        },

        getTotal:  function () {
            if (Config.getInstance().getOption('price_includes_tax')) {
                return this.model.getTotal();
            } else {
                return this.model.getTotal() + this.model.getTax();
            }
        }

    });

});
